import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

const isValidLatLng = (center) =>
  Array.isArray(center) &&
  center.length === 2 &&
  typeof center[0] === "number" &&
  typeof center[1] === "number" &&
  !isNaN(center[0]) &&
  !isNaN(center[1]);

// Moves the map to `center` and, if given, `zoom` - in ONE setView call.
// Two separate calls (setView(center) then setZoom(zoom)) don't work together: setView starts an
// animated pan, and setZoom re-centers on the map's *old* center, cancelling the move.
const CenterMap = ({ center, zoom }) => {
  const map = useMap();
  const lastCenter = useRef(null);

  useEffect(() => {
    const hasZoom = typeof zoom === "number" && !isNaN(zoom);

    if (isValidLatLng(center) && center !== lastCenter.current) {
      lastCenter.current = center;
      map.setView(center, hasZoom ? zoom : map.getZoom());
    } else if (hasZoom && zoom !== map.getZoom()) {
      map.setZoom(zoom);          // zoom only: keep the current view's center
    }
  }, [center, zoom, map]);

  return null;
};

export default CenterMap;